import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UI_SIDEBAR_COLLAPSED_KEY } from 'src/app/core/models/ui-theme';
import { SIDEBAR_TYPE } from '../layouts.model';

/**
 * Modern kabuk.
 *
 * Klasik dikey düzenden farkı: sabit konumlu #page-topbar / .vertical-menu yerine
 * kendi grid yapısını kurar (.m-shell). Böylece klasik yapı CSS'i ile çakışmaz.
 */
@Component({
  selector: 'app-modern',
  templateUrl: './modern.component.html',
  styleUrls: ['./modern.component.scss']
})
export class ModernComponent implements OnInit, OnDestroy {

  /** Sol menü daraltıldı mı (masaüstü). */
  collapsed = false;

  /** Mobil çekmece açık mı (<992px). */
  mobileOpen = false;

  /** Klasik kabuğun body'ye yazdığı, modern kabukta istenmeyen attribute'lar. */
  private static readonly CLASSIC_ATTRIBUTES = [
    'data-sidebar',
    'data-topbar',
    'data-sidebar-size',
    'data-keep-enlarged',
    'data-layout-scrollable'
  ];

  ngOnInit(): void {
    this.clearClassicLayoutState();
    this.collapsed = this.readCollapsed();
  }

  ngOnDestroy(): void {
    // Klasik kabuğa dönüşte VerticalComponent kendi attribute'larını zaten yazar;
    // burası ara durumda bozuk görünüm oluşmaması için güvenlik ağıdır.
    document.body.setAttribute('data-sidebar', SIDEBAR_TYPE);
    document.body.setAttribute('data-layout', 'vertical');
    document.body.setAttribute('data-layout-size', 'fluid');
  }

  /** Masaüstü genişliğine dönüldüğünde açık kalan çekmece durumu temizlenir. */
  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.mobileOpen && window.innerWidth >= 992) {
      this.mobileOpen = false;
    }
  }

  toggleMobileMenu(): void {
    this.mobileOpen = !this.mobileOpen;
  }

  closeMobileMenu(): void {
    this.mobileOpen = false;
  }

  onCollapsedChange(collapsed: boolean): void {
    this.collapsed = collapsed;
  }

  private clearClassicLayoutState(): void {
    ModernComponent.CLASSIC_ATTRIBUTES.forEach(attribute => document.body.removeAttribute(attribute));
    document.body.classList.remove('vertical-collpsed', 'sidebar-enable', 'right-bar-enabled');
    document.body.setAttribute('data-layout', 'vertical');
    document.body.setAttribute('data-layout-size', 'fluid');
  }

  private readCollapsed(): boolean {
    try {
      return localStorage.getItem(UI_SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }
}
